import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Box, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

function Disclaimer() {
    const navigate = useNavigate();

    return (
        <div className='px-20 py-20'>
            <Box sx={{ mb: 4 }}>
                <Button
                    variant="outlined"
                    startIcon={<ArrowBack />}
                    onClick={() => navigate(-1)}
                    sx={{ mb: 3 }}
                >
                    Back
                </Button>
                <h1 className="text-3xl font-bold mb-2">Disclaimer</h1>
                <p className="text-sm text-gray-600 mb-6">Last updated: August 12, 2025</p>
            </Box>
            
            <Typography variant="body1" className="mb-4">
                Claim4accidents.com is a website dedicated to serving the public as an informational resource, providing accurate content about various medical treatments and associated side effects. Claim4accidents.com also connects users with its legal partners, who can evaluate whether an individual has a legal case as a result of side effects or complications caused by a medical treatment.
            </Typography>
            
            <Typography variant="body1" className="mb-4">
                Claim4accidents.com is not affiliated with any pharmaceutical companies or drug manufacturers and does not accept advertising or host online advertisements.
            </Typography>
            
            <Typography variant="body1" className="mb-4">
                There may be times when a visitor comes to Claim4accidents.com looking for assistance with a drug or medical device and Claim4accidents determines that visitor would be better served by a trusted outside service provider or law firm. In those cases, the visitor may be contacted directly by that provider or firm.
            </Typography>
            
            <h2 className="text-xl font-semibold mt-8 mb-2">CONSENT TO CONTACT</h2>
            <Typography variant="body1" className="mb-4">
                By submitting a form about a specific drug or medical device, you consent to be contacted by a Claim4accidents representative or a representative from the appropriate service provider. Any information provided to Claim4accidents.com will be shared with the service provider. Information provided to Claim4accidents.com will not be shared, sold or provided to a data collection company unless specifically authorized.
            </Typography>
            
            <h2 className="text-xl font-semibold mt-8 mb-2">Updated with Latest Information</h2>
            <Typography variant="body1" className="mb-4">
                Claim4accidents.com is continually updated to ensure current information about medications and medical devices and associated side effects is provided to the public. The information on the site is meant to complement a doctor or healthcare professional's advice and should not be used in place of medical advice. It is important to note that most, if not all, drugs or medical devices discussed on Claim4accidents.com are FDA approved.
            </Typography>
            
            <Typography variant="body1" className="mb-4">
                Content found on Claim4accidents.com should not be taken as medical advice and site visitors are encouraged to speak with a medical professional for medical treatment, information and recommendations. Furthermore, site visitors should not discontinue use of a drug or medical device without first seeking the advice of medical professional.
            </Typography>
            
            <Typography variant="body1" className="mb-4">
                Additionally, the legal information on Claim4accidents.com should not be taken as legal advice, as the content on the site is meant to provide general legal information and is not intended to provide information about a specific visitor's situation. The information on Claim4accidents.com is not an offer to create an attorney-client relationship or perform legal services. Visitors should not act or refrain from acting due to information found on this site without the guidance of a qualified and licensed attorney.
            </Typography>
        </div>
    );
}

export default Disclaimer;